module.exports = __webpack_public_path__ + "static/media/iOS.68373506.svg";